import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';

// Semantic flags for the results-page experiments, read once from the bag.

export const useResultsPageConfig = () => {
  var _getPremiumEssentials;
  const experiments = (_getPremiumEssentials = getPremiumEssentialsSafe()) == null ? void 0 : _getPremiumEssentials.experiments;
  const isOn = spec => Boolean(experiments == null ? void 0 : experiments[spec]);
  const isV4 = isOn(ExperimentSpecs.ResultsPageOptimizationsV4);
  return {
    showExactMatchHeadline: isOn(ExperimentSpecs.ResultsPageExactMatchHeadline) || isV4,
    isV4
  };
};
//# sourceMappingURL=useResultsPageConfig.js.map